import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getListNotificationParams,
  INotification,
} from "core/http/service/notification/types";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: INotification[];
  totalRecords: number;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: [],
  totalRecords: 0,
};

const getListNotification = createSlice({
  name: "getListNotification",
  initialState,
  reducers: {
    getListNotificationStart: (
      state,
      action: PayloadAction<getListNotificationParams>
    ) => {
      state.status = ReduxStateType.INIT;
    },
    getListNotificationSuccess: (
      state,
      action: PayloadAction<{ data: INotification[]; totalRecords: number }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...state.data, ...action.payload.data];
      state.totalRecords = action.payload.totalRecords;
    },
    getListNotificationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
      state.totalRecords = 0;
    },
    resetListNotification: (state) => {
      state.status = ReduxStateType.INIT;
      state.data = [];
      state.totalRecords = 0;
    },
  },
});

export const {
  getListNotificationStart,
  getListNotificationSuccess,
  getListNotificationFailed,
  resetListNotification,
} = getListNotification.actions;

export default getListNotification.reducer;
